export const ACCUEIL = "/";
export const ACTIVITES = "/Activités";
export const GALERIE = "/Galerie";
export const INFORMATIONS = "/Informations";
export const ADMIN = "/Admin";
